import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { isObject, isUndefined } from "lodash-es";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { GameResponse } from "../game/game.model";

import { UserGamesConfigService } from "./user-games.config";
import { GetAllLastPlayedParams } from "./user-games.model";

@Injectable({
	providedIn: "root",
})
export class UserGamesService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: UserGamesConfigService
	) {}

	getAllLastPlayed(params: GetAllLastPlayedParams = { take: 12 }): Observable<string[]> {
		const searchParams: Record<string, any> = {};

		if (params && isObject(params)) {
			if (!isUndefined(params.take)) {
				searchParams[`take`] = `${params.take}`;
			}

			if (!isUndefined(params.from)) {
				searchParams[`from`] = params.from;
			}
		}

		return this.httpClient
			.get<GameResponse[]>({
				url: this.config.getAllLastPlayedEndpoint(),
				searchParams,
			})
			.pipe(
				map((games) =>
					games
						.map((game) => game.id)
						.filter((id) => !this.config.getGameIdsHiddenFromLastPlayed().includes(id))
				)
			);
	}
}
